export default __webpack_public_path__ + "static/media/audio_30_ballena.f3a6de42.mp3";